import axios from 'axios'

function logout(pUrl, pToken) {
    const URI = `${pUrl}/api/logout`
    const headers = { Authorization : `Bearer ${pToken}`}
    return axios.post(URI, null, { headers })
}

export { logout }